import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { User } from '@xpo-ltl/sdk-common';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import { NotAuthorizedComponent } from '../components/not-authorized/not-authorized.component';
import { DisputeLoginService } from '../services/users/dispute-login.service';
import { UserService } from '../services/users/user.service';
import { XpoDialogManagerService } from '../services/xpo-dialog-manager.service';
import { XpoLtlRoleSwitcherService, XpoLtlRoleSwitcherData, XpoLtlLoggedInUserService } from '@xpo-ltl/ngx-ltl';
import { ConfigManagerService } from '@xpo-ltl/config-manager';
import { ConfigManagerProperties } from '../enums/config-manager-properties.enum';

@Injectable({
  providedIn: 'root',
})
export class RoleCheckGuard implements CanActivate {
  constructor(
    // private loginService: XpoLtlLoggedInUserService,
    private loginService: DisputeLoginService,
    private config: ConfigManagerService,
    private route: Router,
    private dialogManager: XpoDialogManagerService,
    private userService: UserService,
    private roleSwitcherService: XpoLtlRoleSwitcherService
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean | Observable<boolean> | Promise<boolean> {
    return this.loginService.getLoggedInUser().pipe(
      map(() => {
        if (this.userService.isAuthorizedUser()) {
          return true;
        }
        this.showNotAuthorizedDialog();
        return false;
      }),
      catchError((error) => {
        this.userService.currentUser = undefined;
        this.showNotAuthorizedDialog();
        return of(false);
      })
    );
    // return true;
  }

  private showNotAuthorizedDialog() {
    this.dialogManager.alert(
      {
        titleText: 'No Authorization',
        contentComponent: NotAuthorizedComponent,
        injectedData: of({ isSuccess: false }),
        hideDismissButton: true,
      },
      {
        disableClose: true,
        width: '600',
      }
    );
  }
}
